import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, FormControl, ValidationErrors, ControlContainer, NgForm } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { UserSubmittableDataBatch } from '../_models/user-submittable-data-batch';
import { UserSubmittableDataRecord } from '../_models/user-submittable-data-record';

import { InjectionService } from '../_services/injection.service';

@Component({
  selector: 'app-user-submittable-data-grid',
  templateUrl: './user-submittable-data-grid.component.html',
  styleUrls: ['./user-submittable-data-grid.component.css']
})
export class UserSubmittableDataGridComponent implements OnInit {

  @Input()
  public DateFieldName: string = "InjectionDate";

  @Input()
  public dateFormat: string = null;
  
  public displayedColumns: string[] = []; 

  public flexibleColumns: string[] = [];

  public auxiliaryFormState: Array<any> = new Array<any>();

  dataSource = new BehaviorSubject<AbstractControl[]>([]);
  
  protected _columnData: any = {};
  protected _rowValidators: Array<any>;

  @Input()
  public set columnData(value: any) {
    this._columnData = value;

    this.buildColumnLists();
  }

  public get columnData() {
    return this._columnData;
  }

  @Input()
  public set rowValidators(value: Array<any>) {
    this._rowValidators = value;
  }

  public get rowValidators() {
    return this._rowValidators;
  }

  private _userSubmittableService: any;

  @Input()
  public set userSubmittableService(value: any) {
    this._userSubmittableService = value

    this.handleSubmittableServiceSet();
  }

  public get userSubmittableService() {
    return this._userSubmittableService;
  }
  
  injectionDataGridForm: FormGroup;

  injectionFormRows: FormArray = this.formBuilder.array([]);

  public injectionForm: FormGroup | any = this.formBuilder.group({
    'InjectionRows': this.injectionFormRows
  });

  injectionData: any;

  constructor(
    public formBuilder: FormBuilder,
    public injectionService: InjectionService
  ) {

  }

  ngOnInit(): void {
  }

  handleSubmittableServiceSet() {

    //Subscribe to the current injection batch
    this.userSubmittableService.currentBatch.subscribe((newBatch: UserSubmittableDataBatch) => {

      this.clearForm();

      if(newBatch != null) {
        //When we have a
        this.buildForm(newBatch);
      }
      
    });
  }
  
  buildColumnLists() {
    let keys = Object.keys(this._columnData);

    let displayedColumnsKeys = keys.slice();

    displayedColumnsKeys.unshift(this.DateFieldName);

    this.flexibleColumns = keys;
    this.displayedColumns = displayedColumnsKeys;
  }

  buildForm(newBatch: UserSubmittableDataBatch) {

    //save original data format for template reference
    this.injectionData = newBatch;

    this.auxiliaryFormState = new Array<any>();

    newBatch.Injections.forEach((inj: UserSubmittableDataRecord, index) => {
      this.addInjectionFormRow(inj);

      //Create the auxiliary state object.
      this.addAuxiliaryStateObj(inj);

      let keys = Object.keys(this.columnData);

      keys.forEach((key) => {

        var columnProps = this.columnData[key];

        if(columnProps.type == "manytomany") {
          this.syncManyToManyOptions(key, index);
        }

      });
    });

    

    this.dataSource.next(this.injectionFormRows.controls);
  }

  addInjectionFormRow(inj: UserSubmittableDataRecord) {

    function IsDateValid(control: AbstractControl) {
      var testVal = control.value;

      var earliestAllowable = new Date('2010-01-01');

      var ret: any = {};

      
      let parsedDate = new Date(testVal);

      if (testVal == null) {
        ret.noDate = true;
      }
      else if (!(testVal instanceof Date) && !(parsedDate instanceof Date)) {
        ret.noDate = true;
      }
      else if (testVal < earliestAllowable) {
        ret.outOfBounds = true;
      }

      return ret;
    }

    let d = inj;

    let row = this.formBuilder.group({});

    //Add the injection date control, which is always shown on our injection data grid.
    var injDateControl = this.formBuilder.control(d[this.DateFieldName], [IsDateValid]);

    row.addControl(this.DateFieldName, injDateControl);

    //Now we do the variable ones...
    var columnKeys = Object.keys(this.columnData);

    columnKeys.forEach((key) => {
      let column = this.columnData[key];

      let validators = [];

      //Add the required validator, if needed.
      if(column.required != null && column.required === true) {
        validators.push(Validators.required)
      }

      //Add the minimum validator, if needed.
      if(column.min != null && !isNaN(column.min)){
        validators.push(Validators.min(column.min))
      }

      //Add the maximum validator, if needed.
      if(column.max != null && !isNaN(column.max)) {
        validators.push(Validators.max(column.max))
      }

      if(column.customValidators != null && column.customValidators.length > 0)
      {
        //Add the custom validators;
        column.customValidators.forEach((validator) => {
          validators.push(validator);
        });
      }

      //Grab the field value out of our data model...
      let value = d[key];

      if(column.type == "manytomany"){
        if(value.length > 0) {
          let arrValue = value.join(",");

          value = arrValue;

        }
      }

      let field = this.formBuilder.control(value, validators);

      row.addControl(key, field);
    });

    if(this.rowValidators != null) {

    }

    this.injectionFormRows.push(row);
  }

  addAuxiliaryStateObj(inj: UserSubmittableDataRecord) {
    let auxObj = {};

    //Now we do the variable ones...
    var columnKeys = Object.keys(this.columnData);

    columnKeys.forEach((key) => {
      let column = this.columnData[key];

      let auxFieldData = {};

      //If it's a many to many field...
      if(column.type == "manytomany") {

        column.options.forEach((option) => {
          auxFieldData[option.value] = false;
        });
      }

      auxObj[key] = auxFieldData;
    });

    this.auxiliaryFormState.push(auxObj);
  }
  
  clearForm() {
    this.injectionFormRows.clear();
  }

  fillColumn(columnName: string) {
    var rowsArray: FormArray = <FormArray>this.injectionForm.get('InjectionRows');

    //Look at the first row, and make sure our control exists.
    var firstRowGroup = <FormGroup>rowsArray.get((0).toString());

    if (firstRowGroup != null) {
      var field = firstRowGroup.get(columnName);

      if (field != null) {
        var lastValue = null;
        for (var i = 0; i < rowsArray.length; i++) {
          var rowGroup = <FormGroup>rowsArray.get(i.toString());

          var field = rowGroup.get(columnName);

          if (lastValue == null && field.value != null) {
            lastValue = field.value;
          }
          else if(lastValue != null) {
            this.setFieldValue(columnName, i, lastValue);
          }
        }
      }
    }
  }

  clearColumn(columnId: string) {
    for(var i=0; i < this.injectionFormRows.controls.length; i++) {

      this.setFieldValue(columnId, i, null);
    }
  }

  setFieldValue(columnId, index, newValue) {
    //Get the row
    let row = this.injectionFormRows.at(index);

    //Get the field
    let field = row.get(columnId);

    //Get our column parameters.
    let columnData = this.columnData[columnId];

    if(columnData.type == "checkbox") {
      //In the case of the checkbox, if our value is not a true or false, set it to false, to avoid the possibility of making the form unrecoverably invalid.
      if(newValue !== false && newValue !== true) {
        newValue = false;
      }
    }

    //Actually set the form value
    field.setValue(newValue);

    //Do any follow up operations, such as syncing our auxiliary business.
    if(columnData.type == "manytomany") {
      this.syncManyToManyOptions(columnId, index);
    }
  }

  manyToManyChange(columnId, option, index, newValue) {
    this.auxiliaryFormState[index][columnId][option.value] = newValue;

    this.syncManyToManyHiddenFormField(columnId, option, index);

  }

  syncManyToManyHiddenFormField(columnId, option, index) {

    let values = [];

    let options = this.columnData[columnId].options;

    let selectedValues = [];

    options.forEach((opt) => {
      let isSelected = this.auxiliaryFormState[index][columnId][opt.value];

      if(isSelected) {
        selectedValues.push(opt.value);
      }
    });

    let csvString = selectedValues.join(',');

    let row = this.injectionFormRows.at(index);

    let control = row.get(columnId);

    control.setValue(csvString);
  }

  syncManyToManyOptions(columnId, index) {
    let row = this.injectionFormRows.controls[index];

    let control = row.get(columnId);

    let curVal = control.value;

    let parts = [];
    //curval can be either a string or an array
    //In the case of a many to many, we need to substitute an empty string
    if (curVal) {
      if (typeof curVal == 'string') {
        parts = curVal.split(',');
      } else if (curVal.constructor === Array) {
        parts = curVal;
      }
    }


    let optionValKeys = Object.keys(this.auxiliaryFormState[index][columnId]);

    for(var i=0; i < optionValKeys.length; i++) {
      var valKey = optionValKeys[i];

      if(parts.indexOf(valKey) >= 0) {
        this.auxiliaryFormState[index][columnId][valKey] = true;
      }
      else {
        this.auxiliaryFormState[index][columnId][valKey] = false;
      }
    }
  }

  //Returns the contents of the form, with some processing to distill the many to many fields into arrays, as opposed to csv strings
  getValues() {
    let values = this.injectionForm.value;

    let newValues = {
      InjectionRows: []
    };

    for(let i=0; i < values.InjectionRows.length; i++) {
      let row = values.InjectionRows[i];
      let keys = Object.keys(row);

      let newRow = {};

      for(let j = 0; j < keys.length; j++) {
          let key = keys[j];

          if(key != "InjectionDate"){
            let colData = this.columnData[key];

        

          let value = row[key];

          if(colData != null && colData.type == "manytomany"){
            newRow[key] = value.split(',');
          }
          else {
            newRow[key] = value;
          }
        }
      }

      newValues.InjectionRows.push(newRow);
    }

    return newValues;
  }

  patchValues(injection, index) {
    this.injectionForm.controls.InjectionRows.controls[index].patchValue(injection);
  }
}
